import ContainerLayout from "../../../layouts/two-columns/container-layout";
import Description from "./components/description.component";

const ChaptersIndex = () => {
  const breadcrumbPath = "Membership%2FChapters-Local-Networks";

  return (
    <ContainerLayout breadcrumbPath={breadcrumbPath} isBreadcrumbPath={true} showAds={true}>
      <Description />
    </ContainerLayout>
  );
};

export default ChaptersIndex;